export const fieldNames = {
  SERVICE_NAME: 'serviceName',
  BUSINESS_AND_PURPOSE: 'businessAndPurpose',
  DOES_HAS_CONTENT: 'doesHasContent',
  CONTENT_TYPE: 'contentType',
  OTHER_CONTENT_TYPE: 'otherContentType',
  FEATURE_AND_FUNCTIONALITY: 'featureAndFunctionality',
  USER_IMPROVEMENTS: 'userImprovements',
  SELECTED_PACKAGE: 'selectedPackage',
  OLD_WEBSITE_URL: 'oldWebsiteUrl',
  OLD_WEBSITE_PLATFORM: 'oldWebsitePlatform',
  OTHER_OLD_WEBSITE_PLATFORM: 'otherOldWebsitePlatform',
  MIGRATION_REASON: 'migrationReason',
  OTHER_MIGRATION_REASON: 'otherMigrationReason',
  PRICE: 'price',
};

export const serviceNameValues = {
  BUILD_YOUR_DREAM_SITE: 'Build your dream site',
  REVAMP_YOUR_WEBSITE: 'Revamp your website',
  MIGRATE_YOUR_SITE_TO_YOLA: 'Migrate your site to Yola',
};

export const doesHasContentValues = {
  YES: 'Yes',
  NO: 'No',
};

export const packageValues = {
  BASIC_WEBSITE: 'Basic website',
  ADVANCED_WEBSITE: 'Advanced website',
  CUSTOM_WEBSITE: 'Custom website',
  REFRESH_AND_REFINE: 'Refresh & refine',
  TRANSFORM_AND_INNOVATE: 'Transform & innovate',
  WEBSITE_MIGRATION: 'Website migration',
  MIGRATION_AND_REVAMP: 'Migration & revamp',
};

export const packageValuesToPriceValues = {
  [packageValues.BASIC_WEBSITE]: '~150 US$*',
  [packageValues.ADVANCED_WEBSITE]: '~300 US$*',
  [packageValues.CUSTOM_WEBSITE]: 'custom',
  [packageValues.REFRESH_AND_REFINE]: '~150 US$*',
  [packageValues.TRANSFORM_AND_INNOVATE]: '~300 US$*',
  [packageValues.WEBSITE_MIGRATION]: '~150 US$*',
  [packageValues.MIGRATION_AND_REVAMP]: '~300 US$*',
};

export const OTHER_VALUE = 'Other';
